import { TFunction } from "react-i18next";

import { UploadValueProps } from ".";
import { Company } from "../../../../models/company";
import { UploadCSVType } from "../../../../util/enums";
import { isShipmentTracking } from "../../../../util/validation";

export const GET_UPLOAD_OWN_LIST = (
  translate: TFunction<"translation", undefined>,
  company?: Company
): UploadValueProps[] =>
  isShipmentTracking(company)
    ? [
        {
          id: UploadCSVType.SHIPMENT,
          title: translate("shipment"),
          description: translate("usingShipeeziSSampleData"),
          information: "",
          value: [],
        },
      ]
    : [
        // Inventory List (with info icon) - Left Column
        {
          id: UploadCSVType.INVENTORY_LIST,
          title: translate("inventoryList"),
          description: translate("usingShipeeziSDefault"),
          information: translate("iso174511"),
          value: [],
        },
        // Left Column - Inventory subcategories
        {
          id: UploadCSVType.INVENTORY_LOCATION,
          title: translate("location"),
          description: translate("usingShipeeziSSampleData"),
          information: "",
          value: [],
        },
        {
          id: UploadCSVType.INVENTORY_PACKAGE_TYPE,
          title: translate("packagingType"),
          description: translate("usingShipeeziSSampleData"),
          information: "",
          value: [],
        },
        {
          id: UploadCSVType.INVENTORY_PREPARATION_METHOD,
          title: translate("methodOfPreparation"),
          description: translate("usingShipeeziSSampleData"),
          information: "",
          value: [],
        },
        {
          id: UploadCSVType.INVENTORY_MODE,
          title: translate("modeType"),
          description: translate("usingShipeeziSSampleData"),
          information: "",
          value: [],
        },
        {
          id: UploadCSVType.INVENTORY_EXCEPTION,
          title: translate("exceptionCodes"),
          description: translate("usingShipeeziSSampleData"),
          information: "",
          value: [],
        },
        // Right Column
        {
          id: UploadCSVType.INVENTORY_EXCEPTION_LOCATION,
          title: translate("exceptionLocationCode"),
          description: translate("usingShipeeziSSampleData"),
          information: "",
          value: [],
        },
        {
          id: UploadCSVType.INSTRUCTIONS,
          title: translate("instructions"),
          description: translate("usingShipeeziSSampleData"),
          information: translate(
            "theseInstructionsCanBeUsedInTheSalesAndOperationsAppForUpliftDeliveryOrMoveCoordinator"
          ),
          value: [],
        },
        // TODO: Add Destination when backend support is confirmed
        // {
        //   id: UploadCSVType.INVENTORY_DESTINATION,
        //   title: translate("destination"),
        //   description: translate("usingShipeeziSSampleData"),
        //   information: "",
        //   value: [],
        // },
        {
          id: UploadCSVType.SERVICES,
          title: translate("services"),
          description: translate("usingShipeeziSSampleData"),
          information: translate("oneServiceTypeWillBeCreated"),
          value: [],
        },
        {
          id: UploadCSVType.ACCESS,
          title: translate("access"),
          description: translate("usingShipeeziSSampleData"),
          information: translate("usualAccessQuestionsWillBeCreatedHere"),
          value: [],
        },
        {
          id: UploadCSVType.MATERIALS,
          title: translate("listOfMaterials"),
          description: translate("usingShipeeziSSampleData"),
          information: translate("aFewCommonTypesOfPackingMaterialsWillBeLoaded"),
          value: [],
        },
        // Fleet and Staff are not shown in the main list per Figma design
        // They may be available in other sections or added later
      ];

export const GET_UPLOAD_SHIPEEZI_LIST = (
  translate: TFunction<"translation", undefined>
): UploadValueProps[] => [
  {
    id: UploadCSVType.INVENTORY_LIST,
    title: translate("inventoryListIso174511"),
    description: translate(
      "itemsRoomsPackagingTypeMethodOfPreparationModeTypeExceptionCodesExceptionLocationCodeItemInstructionsAndItemDestination"
    ),
    information: translate("inventoryListIso174511"),
    value: [],
  },
  {
    id: UploadCSVType.FLEET,
    title: translate("fleet"),
    description: translate("oneVehicleWillBeCreated"),
    information: translate("oneVehicleWillBeCreated"),
    value: [],
  },
  {
    id: UploadCSVType.MATERIALS,
    title: translate("listOfMaterials"),
    description: translate("aFewCommonTypesOfPackingMaterialsWillBeLoaded"),
    information: translate("aFewCommonTypesOfPackingMaterialsWillBeLoaded"),
    value: [],
  },
  {
    id: UploadCSVType.SERVICES,
    title: translate("services"),
    description: translate("oneServiceTypeWillBeCreated"),
    information: translate("oneServiceTypeWillBeCreated"),
    value: [],
  },
  {
    id: UploadCSVType.STAFF,
    title: translate("onFieldStaff"),
    description: translate("oneStaffWillBeCreated"),
    information: translate("oneStaffWillBeCreated"),
    value: [],
  },
  {
    id: UploadCSVType.INSTRUCTIONS,
    title: translate("instructions"),
    description: translate(
      "theseInstructionsCanBeUsedInTheSalesAndOperationsAppForUpliftDeliveryOrMoveCoordinator"
    ),
    information: translate(
      "theseInstructionsCanBeUsedInTheSalesAndOperationsAppForUpliftDeliveryOrMoveCoordinator"
    ),
    value: [],
  },
  {
    id: UploadCSVType.ACCESS,
    title: translate("access"),
    description: translate("usualAccessQuestionsWillBeCreatedHere"),
    information: translate("usualAccessQuestionsWillBeCreatedHere"),
    value: [],
  },
];
